var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "topic-column",
    on: {
      "dragover": function ($event) {
        $event.preventDefault();
        return function () {}.apply(null, arguments);
      },
      "drop": function ($event) {
        $event.preventDefault();
        return function () {}.apply(null, arguments);
      },
      "dragenter": _vm.throttleDragoverTopic
    }
  }, [_c('grid', {
    attrs: {
      "length": _vm.length,
      "row-height": _vm.rowHeight
    }
  }, [_vm._t("default")], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }